import React from "react";

const SITE_URL = "https://www.westlaportraits.com";

function LocalBusinessSchema() {
  const data = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "ProfessionalService"],
    "@id": `${SITE_URL}/#business`,
    name: "West LA Portraits",
    url: `${SITE_URL}/`,
    image: `${SITE_URL}/og-home.jpg`,
    logo: `${SITE_URL}/logo.png`,
    description:
      "West LA Portraits is a Los Angeles photography studio specializing in professional headshots, branding portraits, graduation photography, family photography, and wedding photography.",

    priceRange: "$$",

    areaServed: [
      {
        "@type": "City",
        name: "Los Angeles",
      },
      {
        "@type": "City",
        name: "Santa Monica",
      },
      {
        "@type": "City",
        name: "Culver City",
      },
      {
        "@type": "City",
        name: "Beverly Hills",
      },
      {
        "@type": "Place",
        name: "West Los Angeles",
      },
      {
        "@type": "Place",
        name: "Brentwood",
      },
    ],

    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Photography services",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Professional Headshot Photography",
            description:
              "Professional headshots for individuals, creatives, entrepreneurs, and business teams in Los Angeles.",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Branding Portrait Photography",
            description:
              "Personal branding portraits and editorial-style photography for professionals and small businesses.",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Graduation Photography",
            description:
              "Graduation portraits for UCLA and Los Angeles-area graduates.",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Family Photography",
            description:
              "Natural family portrait sessions in Los Angeles and nearby communities.",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Wedding Photography",
            description:
              "Wedding photography focused on candid moments, portraits, and meaningful celebrations.",
          },
        },
      ],
    },

    sameAs: ["https://www.instagram.com/westlaportraits"],
  };

  return (
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  );
}

export default LocalBusinessSchema;